var storefrontApp = angular.module('storefrontApp');
storefrontApp.service('giftcardService', ['$http', function ($http) {
    return {
        getGiftCardImages: function () {
            return $http.get('giftcard/giftcardImages');
        },
        getActiveGiftcardsByUserId: function(){
            return $http.get('storefrontapi/account/getactivegiftcards');
        },
        applyGiftcardsOnCart: function (uniqueCertIds){
            return $http.post('storefrontapi/cart/applygiftcardsoncart?uniqueCertIds=' + uniqueCertIds);
        },
        redeemGiftCard: function(uniqueGiftCardId){
            return $http.post('storefrontapi/account/redeemGiftCard?uniqueGiftCardId='+ uniqueGiftCardId);
        }
    }
}]);
